import Vue from 'vue'
import VueRouter from 'vue-router'
import VodView from './views/VOD/VodView.vue'
import VodHome from './views/VOD/VodHome.vue'
const VodWebinars = () => import('./views/VOD/VodWebinars.vue')
const VodWebinar = () => import('./views/VOD/VodWebinar.vue')
const Course = () => import('./views/VOD/Course/Course.vue')
const VodAccountSettings = () => import('./views/VOD/VodAccountSettings.vue')
const VodResetPassword = () => import('./views/VOD/VodResetPassword.vue')
const VodStatus = () => import('./views/VOD/VodStatus.vue')
import SupportView from './views/Support/SupportView.vue'
import SupportCustomers from './views/Support/Customers/SupportCustomers.vue'
const SupportWebinars = () =>
    import('./views/Support/Webinars/SupportWebinars.vue')
const WebinarCreator = () =>
    import('./views/Support/Webinars/WebinarCreator.vue')
const SupportConferences = () =>
    import('./views/Support/Conferences/SupportConferences.vue')
const ConferenceCreator = () =>
    import('./views/Support/Conferences/ConferenceCreator.vue')
const SupportCourses = () =>
    import('./views/Support/Courses/SupportCourses.vue')
const CourseCreator = () => import('./views/Support/Courses/CourseCreator.vue')
const SupportPromos = () => import('./views/Support/Promos/SupportPromos.vue')
import store from './store'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        component: VodView,
        children: [
            {
                path: '',
                component: VodHome
            },
            {
                path: 'webinars',
                component: VodWebinars
            },
            {
                path: 'webinars/:type',
                component: VodWebinars
            },
            {
                path: 'webinar/:uuid',
                component: VodWebinar
            },
            {
                path: 'course/:uuid',
                component: Course
            },
            {
                path: 'settings',
                component: VodAccountSettings,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'vod/status/:type',
                component: VodStatus
            },
            {
                path: 'vod/reset/:token',
                component: VodResetPassword
            }
        ]
    },
    {
        path: '/support',
        component: SupportView,
        children: [
            {
                path: '',
                component: SupportCustomers
            },
            {
                path: 'webinars',
                component: SupportWebinars
            },
            {
                path: 'webinars/:webinar',
                component: WebinarCreator
            },
            {
                path: 'conferences',
                component: SupportConferences
            },
            {
                path: 'conferences/:conference',
                component: ConferenceCreator
            },
            {
                path: 'courses',
                component: SupportCourses
            },
            {
                path: 'courses/:course',
                component: CourseCreator
            },
            {
                path: 'promos',
                component: SupportPromos
            }
        ]
    }
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const user = store.state.user
    try {
        if (to.matched.some(record => record.meta.requiresAuth) && !user.mail) {
            next({
                path: '/'
            })
        } else {
            next({})
        }
    } catch (error) {
        console.log(error)
    }
})
export default router
